import { getQuickscanQuestions } from './quickscan-questions.js';
const RISK_WEIGHT = {
    low: 1,
    medium: 2,
    high: 3,
};
const MAX_RISK_WEIGHT = RISK_WEIGHT.high;
const RISK_THRESHOLDS = {
    low: 75,
    medium: 50,
};
const TOP_N_HIGHLIGHTS = 5;
export function validateQuickscanAnswers(companyType, answers) {
    const questions = getQuickscanQuestions(companyType);
    const missingQuestionIds = [];
    for (const question of questions) {
        const answer = answers[question.id];
        if (!answer) {
            missingQuestionIds.push(question.id);
            continue;
        }
        const isValidOption = question.options.some((o) => o.value === answer);
        if (!isValidOption) {
            missingQuestionIds.push(question.id);
        }
    }
    return {
        valid: missingQuestionIds.length === 0,
        missingQuestionIds,
    };
}
export function calculateQuickscanResult(companyType, answers) {
    const questions = getQuickscanQuestions(companyType);
    const grouped = groupByCategory(questions);
    const categoryScores = [];
    const strengths = [];
    const concerns = [];
    let totalScore = 0;
    let maxPossibleScore = 0;
    for (const [categoryId, categoryQuestions] of grouped) {
        let categoryScore = 0;
        let categoryMaxScore = 0;
        for (const question of categoryQuestions) {
            const answerValue = answers[question.id];
            const selectedOption = question.options.find((o) => o.value === answerValue);
            categoryMaxScore += MAX_RISK_WEIGHT;
            if (!selectedOption) {
                continue;
            }
            const questionScore = MAX_RISK_WEIGHT - RISK_WEIGHT[selectedOption.risk] + 1;
            categoryScore += questionScore;
            const highlight = `${question.question} - ${selectedOption.label}`;
            if (selectedOption.risk === 'low') {
                strengths.push(highlight);
            }
            else if (selectedOption.risk === 'high') {
                concerns.push(highlight);
            }
        }
        const percentage = categoryMaxScore > 0
            ? Math.round((categoryScore / categoryMaxScore) * 100)
            : 0;
        categoryScores.push({
            categoryId,
            categoryTitle: titleForCategory(categoryId),
            score: categoryScore,
            maxScore: categoryMaxScore,
            percentage,
            riskLevel: riskLevelFromPercentage(percentage),
        });
        totalScore += categoryScore;
        maxPossibleScore += categoryMaxScore;
    }
    const readinessPercentage = maxPossibleScore > 0
        ? Math.round((totalScore / maxPossibleScore) * 100)
        : 0;
    return {
        companyType,
        readinessPercentage,
        riskLevel: riskLevelFromPercentage(readinessPercentage),
        categoryScores,
        strengths: strengths.slice(0, TOP_N_HIGHLIGHTS),
        concerns: concerns.slice(0, TOP_N_HIGHLIGHTS),
    };
}
function groupByCategory(questions) {
    const map = new Map();
    for (const q of questions) {
        const list = map.get(q.category) ?? [];
        list.push(q);
        map.set(q.category, list);
    }
    return map;
}
function riskLevelFromPercentage(percentage) {
    if (percentage >= RISK_THRESHOLDS.low)
        return 'low';
    if (percentage >= RISK_THRESHOLDS.medium)
        return 'medium';
    return 'high';
}
const CATEGORY_TITLES = {
    profiel: 'Profiel & Scope',
    certificering: 'Certificering',
    compliance: 'Administratie & Compliance',
    financieel: 'Financiële Positie',
    planning: 'Planning & Voorbereiding',
};
function titleForCategory(categoryId) {
    return CATEGORY_TITLES[categoryId] ?? categoryId;
}
//# sourceMappingURL=scoring.js.map